module.exports = __webpack_public_path__ + "static/rhs@2x-5b836e2d666203bd417288ca7486f77f.png";